"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentHeader = exports.Body = exports.DocumentBody = exports.default = void 0;

var _ObjectDetailNew = babelHelpers.interopRequireWildcard(require("layouts/ObjectDetailNew"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp;

var DocumentPage =
/*#__PURE__*/
function (_Page) {
  babelHelpers.inherits(DocumentPage, _Page);

  function DocumentPage() {
    babelHelpers.classCallCheck(this, DocumentPage);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(DocumentPage).apply(this, arguments));
  }

  babelHelpers.createClass(DocumentPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(DocumentBody, this.props.content);
    }
  }]);
  return DocumentPage;
}(_ObjectDetailNew.default);

exports.default = DocumentPage;

var DocumentBody =
/*#__PURE__*/
function (_Body) {
  babelHelpers.inherits(DocumentBody, _Body);

  function DocumentBody() {
    babelHelpers.classCallCheck(this, DocumentBody);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(DocumentBody).apply(this, arguments));
  }

  return DocumentBody;
}(_ObjectDetailNew.Body);

exports.Body = exports.DocumentBody = DocumentBody;
var DocumentHeader = (_dec = (0, _decorators.alias)("state.access"), (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DocumentHeader, _Component);

  function DocumentHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DocumentHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DocumentHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "tool", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "record", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "options", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "pdf", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "typeName", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "cta", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "show", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "access", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      access: null
    };
    return _this;
  }

  babelHelpers.createClass(DocumentHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAccess();
      $(document).on('profileUpdated courseStatusUpdated', this.getAccess);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated courseStatusUpdated', this.getAccess);
    }
  }, {
    key: "getAccess",
    value: function getAccess() {
      var _this2 = this;

      var r = new _promisePolyfill.default(function (resolve) {
        if (_this2.show) (0, _fetch.default)("access/".concat(_this2.tool, "/").concat(_this2.record)).then(function (value) {
          return value.json();
        }).then(resolve);else resolve(null);
      });
      r.then(function (access) {
        return _this2.setState({
          access: access
        });
      });
      return r;
    }
  }, {
    key: "doShowDocument",
    value: function doShowDocument(access) {
      // Do we need a window?
      if (!this.pdf) {
        if (!this.targetWindow || this.targetWindow.closed) {
          this.targetWindow = window.open('about:blank', '_blank');
        }
      }

      if (new Date(access.detail.expires) < new Date()) {
        this.getAccess().then(this.doShowDocument);
        return;
      }

      if (!this.pdf) {
        if (this.targetWindow && !this.targetWindow.closed) {
          this.targetWindow.location.href = access.detail.signedDocumentURL;
          this.targetWindow = null;

          require('trackObjectView').default('catalog', this.record, true);
        } // Oops, the window has gone away for whatever the reason. Just bail.


        return;
      }

      var opt = Object.assign({}, this.options);
      if (access.detail.password) opt.password = access.detail.password;
      opt.file = access.detail.signedDocumentURL;
      var optString = Object.keys(opt).map(function (key) {
        return [key, opt[key]].map(encodeURIComponent).join('=');
      }).join('&');
      var f = document.createElement('div');
      f.id = 'document-viewer-modal-wrap';
      f.className = 'modal-wrapper fade';
      f.innerHTML = "\n\t\t\t<div class='modal modal-full modal-full-align-top fade' id='document-viewer-modal' role='dialog' tabindex='-1'\n\t\t\t\taria-hidden='true' data-backdrop-parent='#document-viewer-modal-wrap'\n\t\t\t>\n\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t<div class='modal-header'>\n\t\t\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t\t\t\t<h4 class='modal-title'>\n\t\t\t\t\t\t\t\t<span class='material-icons' data-icon='insert_drive_file'></span>\n\t\t\t\t\t\t\t\tDocument\n\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t<iframe id='document-viewer'></iframe>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");
      f.querySelector('iframe').src = "/admin/platform/plugins/".concat(_corePlugin.default, "/libraries/pdf.js/web/viewer.html?").concat(optString);
      document.body.appendChild(f);
      $(f.querySelector('.modal')).on('hidden.bs.modal', function () {
        return $(f).remove();
      }).modal('show');

      require('trackObjectView').default('catalog', this.record, true);
    }
  }, {
    key: "showDocument",
    value: function showDocument(event) {
      // If it's not a PDF, and it's not expired, just bail.
      if (!this.pdf && new Date(this.access.detail.expires) > new Date()) {
        require('trackObjectView').default('catalog', this.record, true);

        return;
      }

      event.preventDefault();
      this.doShowDocument(this.access);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.show != this.show || prevProps.tool != this.tool || prevProps.record != this.record) {
        this.getAccess();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.access) {
        return _react.default.createElement("div", {
          className: "document-download"
        }, _react.default.createElement(this.access.detail.signedDocumentURL ? "a" : "div", Object.assign({
          className: 'document-download-button',
          onClick: this.showDocument
        }, this.access.detail.signedDocumentURL ? {
          href: this.pdf ? "javascript:void(0)" : this.access.detail.signedDocumentURL
        } : {}, this.access.detail.signedDocumentURL && !this.pdf ? {
          target: '_blank'
        } : {}), _react.default.createElement("div", {
          className: "document-icon"
        }, _react.default.createElement("div", {
          className: "document-type"
        }, this.typeName)), this.access.detail.signedDocumentURL ? _react.default.createElement("span", {
          className: "btn btn-primary"
        }, this.cta) : null));
      }

      return null;
    }
  }]);
  return DocumentHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tool", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "record", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "options", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "pdf", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "typeName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "cta", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "show", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "access", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "getAccess", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "getAccess"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doShowDocument", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doShowDocument"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showDocument", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showDocument"), _class.prototype)), _class));
exports.DocumentHeader = DocumentHeader;